import * as Sentry from '@sentry/browser'

// Actions
import {
  RESET_REFI_REQUEST,
  SEND_REFI_REQUEST,
  SEND_REFI_SUCCESS,
  SEND_REFI_FAILURE,
  SET_REFI_MONTHS_IN_HOME
} from './actionTypes'

// Constants
import { CUSTOMER_MESSAGES } from '../constants/customerMessages'

// Requests
import { createHomeownerMessage } from '../api/mikasa/requests'

// Selectors
import { selectHomeId } from '../store/selectors/home/refinance'
import { selectClientId } from '../store/selectors/client'

export const sendRefiRequestForClient = (message, trackingClient) => async (dispatch, getState) => {
  const state = getState()
  const homeId = selectHomeId(state)
  const clientId = selectClientId(state)

  dispatch({ type: SEND_REFI_REQUEST })

  try {
    const options = {
      topic: CUSTOMER_MESSAGES.REFINANCING.topic,
      topicKey: CUSTOMER_MESSAGES.REFINANCING.topicKey,
      message,
      clientId
    }

    await createHomeownerMessage(homeId, options, trackingClient)

    dispatch({ type: SEND_REFI_SUCCESS })
  } catch (error) {
    Sentry.captureException(error)

    dispatch({ type: SEND_REFI_FAILURE })
  }
}

export const resetRefiRequestStatus = () => dispatch =>
  dispatch({
    type: RESET_REFI_REQUEST
  })

export const setYearsInHome = years => dispatch => {
  dispatch({
    type: SET_REFI_MONTHS_IN_HOME,
    years
  })
}
